export const arcticPrimary = {
  50: '#CEE7E8',
  100: '#B2D7DC',
  200: '#80BDC5',
  300: '#4DA2AE',
  400: '#1A8896',
  500: '#017B8B',
  600: '#016F7D',
  700: '#015662',
  800: '#003D45',
  900: '#00252A',
  950: '#000E0F',
};

export const arcticSecondary = {
  50: '#E0DCEF',
  100: '#CECBE8',
  200: '#AFA9D9',
  300: '#8E86CA',
  400: '#6E64BA',
  500: '#5E53B3',
  600: '#554BA1',
  700: '#423A7E',
  800: '#2F2959',
  900: '#1C1936',
  950: '#0E0B19',
};

export const arcticNeutral = {
  50: '#E3F3F4',
  100: '#D3E4E7',
  200: '#C5D6D6',
  300: '#B7C7C5',
  400: '#A0AAA8',
  500: '#7F8681',
  600: '#616964',
  700: '#3E4644',
  800: '#2F3534',
  900: '#1C2021',
  950: '#111717',
};

export const arcticError = {
  50: '#F0D0D0',
  100: '#EBC1C1',
  200: '#E2A3A3',
  300: '#D67E7E',
  400: '#CA5959',
  500: '#C44747',
  600: '#B14040',
  700: '#8A3232',
  800: '#622323',
  900: '#3B1515',
  950: '#170808',
};

export const arcticSuccess = {
  50: '#D7E9E0',
  100: '#B7D9C7',
  200: '#89C1A2',
  300: '#59A77C',
  400: '#43C87E',
  500: '#2DA262',
  600: '#128245',
  700: '#0D5B30',
  800: '#094122',
  900: '#052715',
  950: '#020D07',
};

export const arcticWarning = {
  50: '#EBE4D6',
  100: '#DFD2BB',
  200: '#CAB48F',
  300: '#B59661',
  400: '#9F7834',
  500: '#95691E',
  600: '#865F1B',
  700: '#694A15',
  800: '#4C350F',
  900: '#2D2009',
  950: '#0F0B03',
};

export const arcticInfo = {
  50: '#CEE0ED',
  100: '#BDD6E6',
  200: '#91BBD6',
  300: '#65A0C5',
  400: '#3984B5',
  500: '#2377AD',
  600: '#206B9C',
  700: '#195479',
  800: '#113B56',
  900: '#0B2434',
  950: '#040C12',
};
